import { render, staticRenderFns } from "./admin.location.new.page.vue?vue&type=template&id=aff7b298&scoped=true&"
import script from "./admin.location.new.page.vue?vue&type=script&lang=js&"
export * from "./admin.location.new.page.vue?vue&type=script&lang=js&"
import style0 from "./admin.location.new.page.vue?vue&type=style&index=0&id=aff7b298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff7b298",
  null
  
)

export default component.exports